export default __webpack_public_path__ + "static/media/about_banner.a211ba49.jpg";